import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Avatar,
  Typography,
  Chip,
  Badge,
  TextField,
  Grid,
  Pagination,
  CircularProgress,
  Modal,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Button,
  List,
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  Divider,
} from "@mui/material";
import { getFilterForGlobal, getGlobalCandidates, postInviteforGlobal } from "../../../../Redux/Reducers/JobReducer";
import ProfessionalCalender from "./ProfessionalCalender";
import * as pdfjsLib from "pdfjs-dist/webpack";
import { useProfileContext } from "../../../ProfileDetailContext";
import CandidateResumeModal from "./CandidateResumeModal";
import { useQuantityContext } from "../../../QuantityContext";
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const InviteModal = ({ open, onClose, companies, selectedCandidate }) => {
  const dispatch = useDispatch();



    const { openSnackbar } = useQuantityContext();

    const handleCompanySelect = async (jobId) => {
      try {
        // Validate required fields
        if (!selectedCandidate?.email || !jobId) {
          openSnackbar("Missing required information", "error");
          return;
        }
    
        const payload = {
          candidate_email: selectedCandidate.email,
          candidate_name: `${selectedCandidate.first_name} ${selectedCandidate.last_name}`,
          candidate_id: selectedCandidate.reference_id,
          job_id: jobId
        };
    
        // Dispatch the API call and wait for response
        const result = await dispatch(postInviteforGlobal(payload)).unwrap();
    
        // Handle success
        openSnackbar(result.message || "Invitation sent successfully!", "success");
        console.log(`Invited ${payload.candidate_name} to job ${jobId}`);
      } catch (error) {
        // Handle API errors
        console.error("Invitation failed:", error);
        openSnackbar(
          error.message || "Failed to send invitation. Please try again.",
          "error"
        );
      } finally {
        onClose();
      }
    };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Select Company to Invite
        </Typography>
        <List sx={{ maxHeight: 300, overflow: 'auto' }}>
          {companies?.map((job) => (
            <ListItem 
              button 
              key={job.id}
              onClick={() => handleCompanySelect(job.id)}
            >
              <ListItemAvatar>
                <Avatar 
                  src={job.company_logo} 
                  alt={job.company_name}
                  sx={{ width: 40, height: 40 }}
                >
                  {job.company_name?.[0]}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={job.company_name}
                secondary={job.role}
              />
            </ListItem>
          ))}
        </List>
        <Button 
          onClick={onClose}
          sx={{ mt: 2, float: 'right' }}
        >
          Cancel
        </Button>
      </Box>
    </Modal>
  );
};


const GlobalCandidates = () => {
  const dispatch = useDispatch();
  const GlobalCandidates = useSelector(
    (state) => state?.jobs?.getGlobalCandidates?.data
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const itemsPerPage = 15;
  const [resumeImageData, setResumeImageData] = useState(null);
  const { openDocumentViewer } = useProfileContext();
  const [openPdf, setPdfOpen] = useState(false);
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [selectedAssignment, setSelectedAssignment] = useState("")
  const [anchorEl, setAnchorEl] = useState(null);
const [selectedRoles, setSelectedRoles] = useState([]);
const [selectedSkills, setSelectedSkills] = useState([]);
const [selectedLocations, setSelectedLocations] = useState([]);
const [selectedExperience, setSelectedExperience] = useState('');
const [selectedModes, setSelectedModes] = useState([]);
const [manualLocationInput, setManualLocationInput] = useState('');
const [appliedFilters, setAppliedFilters] = useState({
  roles: [],
  skills: [],
  locations: [],
  experience: '',
  modes: [],
});

const experienceOptions = [
  '0-1 Year', '1-3 Years', '3-5 Years', 
  '5-10 Years', '10-15 Years', '15-20 Years', '20+ Years'
];

const workModes = ['Remote', 'On-site', 'Hybrid'];

const staticLocations = [
  'Bengaluru', 'Mumbai', 'Delhi', 
  'Chennai', 'Pune', 'Hyderabad'
]
  const Jobs=useSelector((state)=> state?.jobs?.postedJobsData)
  const PostedJobs=Jobs?.posted_jobs
  const globalCandidate=useSelector((state)=> state?.jobs?.getFilterForGlobal)

  console.log("globalCandidate", globalCandidate)

  useEffect(() => {
    dispatch(getGlobalCandidates(searchTerm));
  }, [dispatch]);

// Update the filteredCandidates logic
const filteredCandidates = GlobalCandidates?.filter((candidate) => {
  const matchesSearch = !searchTerm || (
    candidate?.first_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    candidate?.designation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    candidate?.company?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const matchesRole = selectedRoles?.length === 0 || 
    selectedRoles?.some(role => 
      candidate?.designation?.toLowerCase().includes(role.toLowerCase())
    );

  const matchesSkill = selectedSkills?.length === 0 || 
    selectedSkills?.some(skill => 
      candidate?.skills?.some(candidateSkill => 
        candidateSkill?.toLowerCase().includes(skill?.toLowerCase())
      )
    );

  return matchesSearch && matchesRole && matchesSkill;
}) || [];

  const paginatedCandidates = filteredCandidates?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const totalPages = Math.ceil(filteredCandidates?.length / itemsPerPage);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  if (!GlobalCandidates) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}>
        <CircularProgress />
      </Box>
    );
  }

  const handleCandidateClick = async (candidate) => {
    console.log("candidate", candidate);
    setSelectedAssignment(candidate)
    setPdfOpen(true)
  };

  const handleCloseModal = () => {
    setPdfOpen(false);
  };

  const handleInviteClick = (candidate, e) => {
    e.stopPropagation();
    setSelectedCandidate(candidate);
    setInviteModalOpen(true);
  };

  const handleCloseInviteModal = () => {
    setInviteModalOpen(false);
    setSelectedCandidate(null);
  };

  // Add these handler functions
const handleFilterClick = (event) => {
  setAnchorEl(event.currentTarget);
};

const handleFilterClose = () => {
  setAnchorEl(null);
};

const handleRoleSelect = (role) => {
  setSelectedRoles(prev => 
    prev.includes(role) 
      ? prev.filter(r => r !== role) 
      : [...prev, role]
  );
};

const handleSkillSelect = (skill) => {
  setSelectedSkills(prev => 
    prev.includes(skill) 
      ? prev?.filter(s => s !== skill) 
      : [...prev, skill]
  );
};

// Add this function to extract unique roles and skills
const getUniqueFilters = () => {
  const roles = new Set();
  const skills = new Set();

  PostedJobs?.forEach(job => {
    if (job?.role) roles?.add(job?.role);
    if (job?.skills) job?.skills?.forEach(skill => skills?.add(skill));
  });

  return {
    roles: Array.from(roles),
    skills: Array.from(skills)
  };
}

const anyFiltersSelected = !!(
  selectedRoles?.length ||
  selectedSkills?.length ||
  selectedLocations?.length ||
  selectedExperience ||
  selectedModes?.length
)


// Filter handler
const handleApplyFilters = async () => {
  const payload = {
    skills: selectedSkills,
    mode: selectedModes,
    location: selectedLocations,
    experience: selectedExperience,
  };
  try {
    const response = await dispatch(getFilterForGlobal(payload)).unwrap();
    setAppliedFilters({
      roles: selectedRoles,
      skills: selectedSkills,
      locations: selectedLocations,
      experience: selectedExperience,
      modes: selectedModes,
    });
    // Additional success handling...
  } catch (error) {
    // Error handling...
  }
};




  return (
    <Box sx={{ display: "flex", flexDirection: "row", backgroundColor: "#f4f7fe", width: "100%" }}>
      <Box
        sx={{
          width: "70%",
          p: 2,
          backgroundColor: "white",
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
          borderRadius: "5px",
          maxHeight: "90vh",
          overflowY: "scroll",
          scrollbarWidth: "none",
          margin: "20px",
        }}
      >
        <Typography sx={{ color: "black", fontWeight: "bold", mb: 1 }}>Search Candidates</Typography>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
  <TextField
    label="Search"
    variant="outlined"
    size="small"
    sx={{ width: "40%" }}
    onChange={(e) => {
      setSearchTerm(e.target.value);
      setPage(1);
    }}
  />
  <Box>
    {selectedRoles?.length > 0 || selectedSkills?.length > 0 ? (
      <Chip 
        label="Clear Filters" 
        onClick={() => {
          setSelectedRoles([]);
          setSelectedSkills([]);
        }}
        sx={{ mr: 1 }}
      />
    ) : null}
    <Tooltip title="Filter candidates">
      <IconButton 
        color="primary"
        onClick={handleFilterClick}
        sx={{ border: "1px solid", borderColor: "divider" }}
      >
        <FilterAltRoundedIcon />
      </IconButton>
    </Tooltip>
  </Box>

  <Menu
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={handleFilterClose}
  PaperProps={{ sx: { maxHeight: 400, width: 400, padding: "20px" } }}
>
  {/* Designation Section */}
  <MenuItem disabled sx={{ color: "black" }}>Designation</MenuItem>
  <Box sx={{ px: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
    {getUniqueFilters().roles?.map(role => (
      <Chip
        key={role}
        label={role}
        clickable
        variant={selectedRoles?.includes(role) ? 'filled' : 'outlined'}
        color="primary"
        onClick={() => handleRoleSelect(role)}
      />
    ))}
  </Box>

  <Divider sx={{ my: 1 }} />

  {/* Skills Section */}
  <MenuItem disabled>Skills</MenuItem>
  <Box sx={{ px: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
    {getUniqueFilters()?.skills?.map(skill => (
      <Chip
        key={skill}
        label={skill}
        clickable
        variant={selectedSkills?.includes(skill) ? 'filled' : 'outlined'}
        color="secondary"
        onClick={() => handleSkillSelect(skill)}
      />
    ))}
  </Box>

  <Divider sx={{ my: 1 }} />

  {/* Location Section */}
  <MenuItem disabled>Location</MenuItem>
  <Box sx={{ px: 2, mb: 2 }}>
    <TextField
      label="Add Location"
      variant="outlined"
      size="small"
      fullWidth
      value={manualLocationInput}
      onChange={(e) => setManualLocationInput(e.target.value)}
      onKeyPress={(e) => {
        if (e.key === 'Enter' && manualLocationInput) {
          setSelectedLocations((prev) => [...prev, manualLocationInput]);
          setManualLocationInput('');
        }
      }}
    />
    <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {staticLocations?.map(location => (
        <Chip
          key={location}
          label={location}
          clickable
          variant={selectedLocations?.includes(location) ? 'filled' : 'outlined'}
          color="primary"
          onClick={() => setSelectedLocations(prev => 
            prev.includes(location) ? prev?.filter(l => l !== location) : [...prev, location]
          )}
        />
      ))}
    </Box>
  </Box>

  <Divider sx={{ my: 1 }} />

  {/* Experience Section */}
  <MenuItem disabled>Experience</MenuItem>
  <Box sx={{ px: 2, mb: 2 }}>
    <TextField
      select
      label="Select Experience"
      variant="outlined"
      fullWidth
      size="small"
      value={selectedExperience}
      onChange={(e) => setSelectedExperience(e.target.value)}
      SelectProps={{
        native: true,
      }}
    >
      <option value=""></option>
      {experienceOptions?.map(exp => (
        <option key={exp} value={exp}>{exp}</option>
      ))}
    </TextField>
  </Box>

  <Divider sx={{ my: 1 }} />

  {/* Work Mode Section */}
  <MenuItem disabled>Work Mode</MenuItem>
  <Box sx={{ px: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
  {workModes?.map(mode => (
    <Chip
      key={mode}
      label={mode}
      clickable
      variant={selectedModes?.includes(mode) ? 'filled' : 'outlined'}
      color="secondary"
      onClick={() => setSelectedModes(prev => 
        prev.includes(mode) ? prev?.filter(m => m !== mode) : [...prev, mode]
      )} // <-- Closing parenthesis fixed here
    />
  ))}
  </Box>

  <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
    <Button 
      variant="outlined" 
      onClick={() => {
        setSelectedRoles([]);
        setSelectedSkills([]);
        setSelectedLocations([]);
        setSelectedExperience('');
        setSelectedModes([]);
      }}
    >
      Clear All
    </Button>
    <Button 
      variant="contained" 
      onClick={handleApplyFilters}
      disabled={!anyFiltersSelected}
    >
      Apply Filters
    </Button>
  </Box>
</Menu>

       

</Box>
        <Grid container spacing={1} justifyContent="center">
          {paginatedCandidates?.map((candidate) => (
            <Grid item xs={12} sm={6} md={4} lg={2.4} key={candidate?.id}>
              <Box
                sx={{
                  width: "160px",
                  height: "210px",
                  p: 2,
                  borderRadius: 2,
                  border: "1px solid #00000020",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#fff",
                  transition: "all 0.3s ease",
                  "&:hover": { border: "1px solid #0044C6" },
                }}
                onClick={() => handleCandidateClick(candidate)}
              >
                <Badge
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  badgeContent={
                    <Avatar
                      src={
                        candidate?.logo ||
                        "https://i.pinimg.com/736x/ec/d9/c2/ecd9c2e8ed0dbbc96ac472a965e4afda.jpg"
                      }
                      sx={{ width: 24, height: 24, border: "2px solid white" }}
                    />
                  }
                >
                  <Avatar
                    src={candidate?.profile_url}
                    alt={candidate?.first_name}
                    sx={{ width: 60, height: 60, mb: 1 }}
                  >
                    {candidate?.first_name?.[0] || "?"}
                  </Avatar>
                </Badge>
                <Box sx={{ textAlign: "center" }}>
                  <Typography sx={{ color: "black", fontWeight: "bold" }}>{candidate?.first_name}</Typography>
                  <Tooltip title={candidate?.designation || ""} arrow>
    <Typography
      sx={{
        color: "black",
        fontSize: "12px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: 100, // Adjust width as needed
      }}
    >
      {candidate?.designation}
    </Typography>
  </Tooltip>

  <Tooltip title={candidate?.company || ""} arrow>
    <Typography
      sx={{
        color: "black",
        fontSize: "12px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: 100, // Adjust width as needed
      }}
    >
      {candidate?.company}
    </Typography>
  </Tooltip>
                </Box>
                <Chip 
    label="Invite" 
    color="success" 
    variant="outlined" 
    sx={{ mt: 1, cursor: "pointer" }}
    onClick={(e) => handleInviteClick(candidate, e)}
  />
              </Box>
            </Grid>
          ))}
        </Grid>

        {totalPages > 1 && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Pagination count={totalPages} page={page} onChange={handlePageChange} color="primary" />
          </Box>
        )}
      </Box>

     

      <CandidateResumeModal
                    openPdf={openPdf}
                    onClose={handleCloseModal}
                    candidate={selectedAssignment}
                  />

<InviteModal
    open={inviteModalOpen}
    onClose={handleCloseInviteModal}
    companies={PostedJobs}
    selectedCandidate={selectedCandidate}
  />

      <Box sx={{ width: "30%", margin: "20px", maxHeight: "90vh", overflowY: "scroll", backgroundColor: "white", padding: "10px" }}>
        <ProfessionalCalender />
      </Box>
    </Box>
  );
};

export default GlobalCandidates;
